<template>
  <div>
    <v-alert v-show="alert" dense text :type="typestatus">{{textInfo}}</v-alert>
  </div>
</template>

<script>
export default {
  name: "warningAlert",
  data() {
    return {};
  },
  mounted() {},
  props: {
    textInfo: {
      type: String
    },
    typestatus: {
      type: String
    },
    alert: {
      type: Boolean
    }
  }
};
</script>